/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

import React from 'react'
import { HashRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import Routers from './routerMap'
import Error from '../pages/error'
import { PAGE_NAME } from '../config'
import { connect } from "react-redux";
import actionWays from "../redux/actions";
import { userInfoFunc } from '../config/func'

class App extends React.Component {
    render() {
        const { userLoginInfo } = this.props
        let token = userInfoFunc(userLoginInfo);
        return (
            <Router>
                <Switch>
                    {Routers.map((item, index) => {
                        return item.views ?
                            <Route key={index} path={item.path} exact render={props => {
                                document.title = ((item.title == '首页' ? '' : (item.title + ' - ')) + PAGE_NAME) || "title";
                                let componentR = <item.component {...props} />
                                return componentR;
                            }
                            } /> : <Route key={index} path={item.path} exact render={props => {
                                document.title = ((item.title == '首页' ? '' : (item.title + ' - ')) + PAGE_NAME) || "title";
                                let componentR = <item.component {...props} />
                                let componentRect = <Redirect to={{
                                    pathname: '/home',
                                    search: "?redirectUrl=" + props.location.pathname + props.location.search,
                                    state: { from: props.location }
                                }} />
                                let r = !item.isLogin ? componentR : (token ? componentR : componentRect)
                                return r;
                            }
                            } />
                    })}
                    <Route component={Error} />
                </Switch>
            </Router>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userLoginInfo: state.userLoginInfo
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(App)
